import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store/index';
import jwt_decode from 'jwt-decode';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    name: 'signOut',
    path: '/signOut',
    component: () => import('@/views/SignOut.vue'),
  },
  {
    name: 'sso-oidc',
    path: '/sso-oidc',
    component: () => import('@/views/sso-oidc.vue'),
  },
  {
    path: '/',
    name: 'layout',
    component: () => import('@/views/Layout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            name: 'member-list',
            path: '',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/List.vue'),
          },
          {
            name: 'member-auth-list',
            path: 'auth-list',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/AuthList.vue'),
          },
          {
            name: 'member-create',
            path: 'create',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/New.vue'),
          },
          {
            name: 'member-edit',
            path: ':userId',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/Edit.vue'),
            props: true,
            children: [
              {
                name: 'member-add-point',
                path: 'add-point',
                component: () => import(/* webpackChunkName: "member" */ '@/views/member/AddPoints.vue'),
                props: true,
              },
              {
                name: 'member-confirm-forgot-password',
                path: 'forgot-password',
                component: () => import(/* webpackChunkName: "member" */ '@/views/member/ForgotPassword.vue'),
                props: true,
              },
              {
                name: 'member-confirm-forgot-tranpassword',
                path: 'forgot-tranpassword',
                component: () => import(/* webpackChunkName: "member" */ '@/views/member/ForgotTranPassword.vue'),
                props: true,
              },
            ],
          },
          {
            name: 'member-auth',
            path: ':userId/auth',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/UserAuth.vue'),
            props: true,
          },
          {
            name: 'member-points',
            path: ':userId/points',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/PointList.vue'),
            props: true,
            children: [
              {
                name: 'member-point-detail',
                path: ':tid',
                component: () => import(/* webpackChunkName: "member" */ '@/views/member/TranDetail.vue'),
                props: true,
              },
            ],
          },
          {
            name: 'member-smslog',
            path: ':userId/smslog',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/SmsList.vue'),
            props: true,
          },
          {
            name: 'member-signInLogs',
            path: ':userId/signInLogs',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/SignInLogList.vue'),
            props: true,
          },
          {
            name: 'member-invited',
            path: ':userId/invited',
            component: () => import(/* webpackChunkName: "member" */ '@/views/member/Invited.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'merchant',
        name: 'merchant-layout',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'merchant',
            component: () => import(/* webpackChunkName: "merchant" */ '@/views/merchant/MerchantList.vue'),
          },
          {
            path: 'category',
            name: 'category',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'merchantCategoryList',
                component: () => import('@/views/merchant/category/List.vue'),
                children: [
                  {
                    path: 'create',
                    name: 'merchantCategoryCreate',
                    component: () => import('@/views/merchant/category/Form.vue'),
                  },
                  {
                    path: ':id',
                    name: 'merchantCategoryEdit',
                    component: () => import('@/views/merchant/category/Form.vue'),
                    props: true,
                  },
                ],
              },
            ],
          },
          {
            path: 'create',
            name: 'merchantCreate',
            component: () => import(/* webpackChunkName: "merchant" */ '@/views/merchant/Create.vue'),
          },
          {
            path: ':merchantId',
            name: 'merchantEdit',
            component: () => import(/* webpackChunkName: "merchant" */ '@/views/merchant/Edit.vue'),
            props: true,
          },
          {
            path: ':id/merchantannouncement',
            name: 'merchantannouncement',
            component: () => import(/* webpackChunkName: "merchant" */ '@/views/merchant/MerchantAnnouncement.vue'),
          },
          {
            path: ':merchantId/store',
            name: 'storeList',
            component: () => import(/* webpackChunkName: "merchant" */ '@/views/store/Store.vue'),
            props: true,
            children: [
              {
                path: 'create',
                name: 'storeCreate',
                component: () => import(/* webpackChunkName: "merchant" */ '@/views/store/StoreForm.vue'),
                props: true,
              },
              {
                path: ':storeId',
                name: 'storeEdit',
                component: () => import(/* webpackChunkName: "merchant" */ '@/views/store/StoreForm.vue'),
                props: true,
              },
              {
                path: ':storeId/admin',
                name: 'storeAdminList',
                component: () => import(/* webpackChunkName: "merchant" */ '@/views/store/admin/List.vue'),
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'swap-in-point',
        name: 'swap-in-point',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: 'type-management',
            name: 'swap-in-point-type-management',
            component: () => import(/* webpackChunkName: "swap-in" */ '@/views/swap-in-point/TypeManagement.vue'),
          },
          {
            path: 'item',
            name: 'swap-in-point-item',
            component: () => import(/* webpackChunkName: "swap-in" */ '@/views/RouterView.vue'),
            children: [
              {
                path: 'list',
                name: 'swap-in-point-item-list',
                component: () => import(/* webpackChunkName: "swap-in" */ '@/views/swap-in-point/exchange-item/List.vue'),
              },
              {
                path: 'create',
                name: 'swap-in-point-item-list-create',
                component: () => import('@/views/swap-in-point/exchange-item/Create.vue'),
              },
              {
                path: ':id/edit',
                name: 'swap-in-point-item-list-edit',
                component: () => import('@/views/swap-in-point/exchange-item/Edit.vue'),
              },
            ],
          },
          {
            path: 'vouchers',
            name: 'swap-in-point-vouchers',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'swap-in-point-vouchers-list',
                component: () => import('@/views/swap-in-point/voucher/List.vue'),
              },
              {
                path: 'create',
                name: 'swapInPointVoucherCreate',
                component: () => import('@/views/swap-in-point/voucher/AddForm.vue'),
              },
              {
                path: 'import',
                name: 'swapInPointVoucherImport',
                component: () => import('@/views/swap-in-point/voucher/AddForm.vue'),
              },
              {
                path: ':id/edit',
                name: 'swapInPointVoucherEdit',
                component: () => import('@/views/swap-in-point/voucher/EditForm.vue'),
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'swap-out-point',
        name: 'swap-out-point',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: 'product',
            name: 'swapOutProduct',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'swapOutProductList',
                component: () => import('@/views/swap-out-point/product/List.vue'),
              },
              {
                path: 'create',
                name: 'swapOutProductCreate',
                component: () => import('@/views/swap-out-point/product/Create.vue'),
              },
              {
                path: ':id/edit',
                name: 'swapOutProductEdit',
                component: () => import('@/views/swap-out-point/product/Edit.vue'),
              },
              {
                path: ':id/voucher',
                name: 'swapOutProductVoucher',
                component: () => import('@/views/RouterView.vue'),
                children: [
                  {
                    path: '',
                    name: 'swapOutProductVoucherList',
                    component: () => import('@/views/swap-out-point/voucher/List.vue'),
                  },
                  {
                    path: 'create',
                    name: 'swapOutProductVoucherCreate',
                    component: () => import('@/views/swap-out-point/voucher/AddForm.vue'),
                  },
                  {
                    path: 'import',
                    name: 'swapOutProductVoucherImport',
                    component: () => import('@/views/swap-out-point/voucher/AddForm.vue'),
                  },
                  {
                    path: ':vId/edit',
                    name: 'swapOutProductVoucherEdit',
                    component: () => import('@/views/swap-out-point/voucher/EditForm.vue'),
                    props: true,
                  },
                ],
              },
              {
                path: 'category',
                name: 'swapOutProductCategory',
                component: () => import('@/views/RouterView.vue'),
                children: [
                  {
                    path: '',
                    name: 'swapOutProductCategoryList',
                    component: () => import('@/views/swap-out-point/product/category/List.vue'),
                  },
                  {
                    path: 'create',
                    name: 'swapOutProductCategoryCreate',
                    component: () => import('@/views/swap-out-point/product/category/Form.vue'),
                  },
                  {
                    path: ':catId',
                    name: 'swapOutProductCategoryEdit',
                    component: () => import('@/views/swap-out-point/product/category/Form.vue'),
                  },
                ],
              },
              {
                path: 'tag',
                name: 'swapOutProductTag',
                component: () => import('@/views/RouterView.vue'),
                children: [
                  {
                    path: '',
                    name: 'swapOutProductTagList',
                    component: () => import('@/views/swap-out-point/product/Tag/List.vue'),
                  },
                  {
                    path: 'create',
                    name: 'swapOutProductTagCreate',
                    component: () => import('@/views/swap-out-point/product/Tag/Form.vue'),
                  },
                  {
                    path: ':tagId',
                    name: 'swapOutProductTagEdit',
                    component: () => import('@/views/swap-out-point/product/Tag/Form.vue'),
                  },
                  {
                    path: ':tagId/applyProducts',
                    name: 'tagApplyProducts',
                    component: () => import('@/views/swap-out-point/product/Tag/ApplyProducts.vue'),
                    props: true,
                  },
                ],
              },
            ],
          },
          {
            path: 'vouchers',
            name: 'swapOutVoucherList',
            component: () => import('@/views/swap-out-point/voucher/List.vue'),
          },
        ],
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/news/Index.vue'),
        children: [
          {
            path: 'list',
            name: 'news-list',
            component: () => import('@/views/news/List.vue'),
          },
          {
            path: ':newsId/edit',
            name: 'news-edit',
            component: () => import('@/views/news/Edit.vue'),
          },
          {
            path: 'create',
            name: 'news-create',
            component: () => import('@/views/news/Create.vue'),
          },
          {
            path: 'media-list',
            name: 'news-media-list',
            component: () => import('@/views/news/MediaList.vue'),
          },
        ],
      },
      {
        path: 'event',
        name: 'event',
        component: () => import('@/views/event/Index.vue'),
        children: [
          {
            path: 'list',
            name: 'event-list',
            component: () => import('@/views/event/List.vue'),
          },
          {
            path: ':eventId/edit',
            name: 'event-edit',
            component: () => import('@/views/event/Edit.vue'),
          },
          {
            path: 'create',
            name: 'event-create',
            component: () => import('@/views/event/Create.vue'),
          },
        ],
      },
      {
        path: 'promotion-code',
        name: 'promotion-code',
        component: () => import('@/views/promotion-code/Index.vue'),
        children: [
          {
            path: 'list',
            name: 'promotion-code-list',
            component: () => import('@/views/promotion-code/List.vue'),
          },
          {
            path: ':pcode/edit',
            name: 'promotion-code-edit',
            component: () => import('@/views/promotion-code/Edit.vue'),
          },
          {
            path: 'create',
            name: 'promotion-code-create',
            component: () => import('@/views/promotion-code/Create.vue'),
          },
        ],
      },
      {
        path: 'virtualCurrency',
        name: 'virtual',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: 'exchanger',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'virtualExchanger',
                component: () => import('@/views/virtual-currency/exchanger/List.vue'),
              },
              {
                path: 'create',
                name: 'virtualExchangerCreate',
                component: () => import('@/views/virtual-currency/exchanger/Form.vue'),
              },
              {
                path: ':exchangerId/currency',
                component: () => import('@/views/RouterView.vue'),
                children: [
                  {
                    path: '',
                    name: 'exchangerCurrency',
                    component: () => import('@/views/virtual-currency/exchanger/currency/List.vue'),
                    props: true,
                  },
                  {
                    path: 'create',
                    name: 'exchangerCurrencyCreate',
                    component: () => import('@/views/virtual-currency/exchanger/currency/Form.vue'),
                    props: true,
                  },
                  {
                    path: ':currencyId',
                    name: 'exchangerCurrencyEdit',
                    component: () => import('@/views/virtual-currency/exchanger/currency/Form.vue'),
                    props: true,
                  },
                ],
              },
              {
                path: ':exchangerId',
                name: 'virtualExchangerEdit',
                component: () => import('@/views/virtual-currency/exchanger/Form.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'currency',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'virtualCurrency',
                component: () => import('@/views/virtual-currency/currency/List.vue'),
              },
              {
                path: 'create',
                name: 'virtualCurrencyCreate',
                component: () => import('@/views/virtual-currency/currency/Form.vue'),
              },
              {
                path: ':currencyId',
                name: 'virtualCurrencyEdit',
                component: () => import('@/views/virtual-currency/currency/Form.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'dailyThreshold',
            name: 'dailyThreshold',
            component: () => import('@/views/virtual-currency/Threshold.vue'),
          },
        ],
      },
      {
        path: 'scheduledMessage',
        name: 'scheduledMessage',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'scheduledMessageList',
            component: () => import('@/views/scheduled-message/List.vue'),
          },
          {
            path: 'create',
            name: 'scheduledMessageCreate',
            component: () => import('@/views/scheduled-message/Create.vue'),
          },
          {
            path: ':id/edit',
            name: 'scheduledMessageEdit',
            component: () => import('@/views/scheduled-message/Edit.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'shoppingGuide',
        name: 'shoppingGuide',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'shoppingGuideList',
            component: () => import('@/views/shopping-guide/List.vue'),
          },
          {
            path: 'create',
            name: 'shoppingGuideCreate',
            component: () => import('@/views/shopping-guide/Form.vue'),
          },
          {
            path: ':id',
            name: 'shoppingGuideEdit',
            component: () => import('@/views/shopping-guide/Form.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'serviceUpdate',
        name: 'serviceUpdate',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'serviceUpdateList',
            component: () => import('@/views/service-update/List.vue'),
          },
          {
            path: 'create',
            name: 'serviceUpdateCreate',
            component: () => import('@/views/service-update/Form.vue'),
          },
          {
            path: ':id',
            name: 'serviceUpdateEdit',
            component: () => import('@/views/service-update/Form.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'invitation-code',
        name: 'invitationCodeIndex',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'invitationCodeList',
            component: () => import('@/views/invitation-code/List.vue'),
          },
          {
            path: 'create',
            name: 'invitationCodeCreate',
            component: () => import('@/views/invitation-code/Create.vue'),
          },
          {
            path: ':code',
            name: 'invitationCodeEdit',
            component: () => import('@/views/invitation-code/Modify.vue'),
          },
        ],
      },
      {
        path: 'shoppingGiveBack',
        name: 'shoppingGiveBack',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: 'request',
            name: 'shoppingGiveBackRequest',
            component: () => import('@/views/shopping-giveback/request/List.vue'),
          },
          {
            path: 'merchant',
            name: 'merchant',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '',
                name: 'shoppingGiveBackMerchantList',
                component: () => import('@/views/shopping-giveback/merchant/List.vue'),
              },
              {
                path: ':id',
                name: 'shoppingGiveBackMerchantEdit',
                component: () => import('@/views/shopping-giveback/merchant/Form.vue'),
                props: true,
              },
              {
                path: 'create',
                name: 'shoppingGiveBackMerchantCreate',
                component: () => import('@/views/shopping-giveback/merchant/Form.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'payment',
        name: 'paymentList',
        component: () => import('@/views/payment/List.vue'),
      },
      {
        path: 'point-calculator',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'pointCalculatorList',
            component: () => import('@/views/point-calculator/List.vue'),
          },
          {
            path: 'create',
            name: 'pointCalculatorCreate',
            component: () => import('@/views/point-calculator/Create.vue'),
          },
          {
            path: ':id',
            name: 'pointCalculatorEdit',
            component: () => import('@/views/point-calculator/Edit.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/RouterView.vue'),
        children: [
          { path: 'swapOutPoint', name: 'swapOutPointReport', component: () => import('@/views/reports/SwapOut/Point.vue') },
          { path: 'swapOutProduct', name: 'swapOutProductReport', component: () => import('@/views/reports/SwapOut/Product.vue') },
          { path: 'swapOutDiscountCoupon', name: 'swapOutDiscountCouponReport', component: () => import('@/views/reports/SwapOut/DiscountCoupon.vue') },
          { path: 'mobilePayment', name: 'mobilePaymentReport', component: () => import('@/views/reports/SwapOut/MobilePayment.vue') },
          { path: 'userPoint', name: 'userPointReport', component: () => import('@/views/reports/UserPoint.vue') },
          { path: 'swapIn', name: 'swapInReport', component: () => import('@/views/reports/SwapIn.vue') },
          { path: 'storeSummary', name: 'storeSummary', component: () => import('@/views/reports/StoreSummary.vue') },
          { path: 'superPointGenerate', name: 'superPointGenerateReport', component: () => import('@/views/reports/PointGenerate.vue') },
        ],
      },
      {
        path: 'otherPoint',
        name: 'otherPoint',
        component: () => import('@/views/RouterView.vue'),
        children: [
          { path: '/', name: 'otherPointList', component: () => import('@/views/other-point/List.vue') },
          { path: ':id/edit', name: 'otherPointEdit', component: () => import('@/views/other-point/Edit.vue') },
          { path: ':id/activity', name: 'otherPointActivityList', component: () => import('@/views/other-point/activity/List.vue'), props: true },
          { path: ':id/activity/create', name: 'otherPointActivityCreate', component: () => import('@/views/other-point/activity/Create.vue'), props: true },
          { path: ':id/activity/:activityId', name: 'otherPointActivityEdit', component: () => import('@/views/other-point/activity/Edit.vue'), props: true },
        ],
      },
      {
        path: 'home',
        name: 'homeConfig',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: 'banner',
            name: 'bannerIndex',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: 'list',
                name: 'bannerList',
                component: () => import('@/views/home/banner/List.vue'),
              },
              {
                path: 'create',
                name: 'bannerCreate',
                component: () => import('@/views/home/banner/Create.vue'),
              },
              {
                path: ':id/edit',
                name: 'bannerEdit',
                component: () => import('@/views/home/banner/Edit.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'appAdPopup',
            name: 'appAdPopup',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '/',
                name: 'appAdPopupList',
                component: () => import('@/views/home/app-advertisement/List.vue'),
              },
              {
                path: ':id/edit',
                name: 'appAdPopupEdit',
                component: () => import('@/views/home/app-advertisement/Edit.vue'),
                props: true,
              },
              {
                path: 'create',
                name: 'appAdPopupCreate',
                component: () => import('@/views/home/app-advertisement/Create.vue'),
              },
            ],
          },
          {
            path: 'appAdCarousel',
            name: 'appAdCarousel',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '/',
                name: 'appAdCarouselList',
                component: () => import('@/views/home/app-advertisement/List.vue'),
              },
              {
                path: ':id/edit',
                name: 'appAdCarouselEdit',
                component: () => import('@/views/home/app-advertisement/Edit.vue'),
                props: true,
              },
              {
                path: 'create',
                name: 'appAdCarouselCreate',
                component: () => import('@/views/home/app-advertisement/Create.vue'),
              },
            ],
          },
          {
            path: 'popularProductUrl',
            name: 'popularProductUrl',
            component: () => import('@/views/RouterView.vue'),
            children: [
              {
                path: '/',
                name: 'popularProductUrlList',
                component: () => import('@/views/home/popular-product-url/List.vue'),
              },
              {
                path: ':id/edit',
                name: 'popularProductUrlEdit',
                component: () => import('@/views/home/popular-product-url/Edit.vue'),
                props: true,
              },
              {
                path: 'create',
                name: 'popularProductUrlCreate',
                component: () => import('@/views/home/popular-product-url/Create.vue'),
              },
            ],
          },
          {
            path: 'product',
            name: 'homeProduct',
            component: () => import('@/views/home/HomeProduct.vue'),
          },
        ],
      },
      {
        path: 'couponActivity',
        name: 'couponActivity',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '/',
            name: 'couponActivityList',
            component: () => import('@/views/coupon-activity/List.vue'),
          },
          {
            path: 'create',
            name: 'couponActivityCreate',
            component: () => import('@/views/coupon-activity/Create.vue'),
          },
          {
            path: ':activityId/edit',
            name: 'couponActivityEdit',
            component: () => import('@/views/coupon-activity/Edit.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'mission',
        name: 'mission',
        component: () => import('@/views/RouterView.vue'),
        children: [
          {
            path: '/',
            name: 'missionList',
            component: () => import('@/views/mission/List.vue'),
          },
          {
            path: 'create',
            name: 'missionCreate',
            component: () => import('@/views/mission/Create.vue'),
          },
          {
            path: ':missionId/edit',
            name: 'missionEdit',
            component: () => import('@/views/mission/Edit.vue'),
            props: true,
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = (store as any).getters['token/token'];
  if (to.name !== 'login' && to.name !== 'sso-oidc') {
    const jwt: any = (token && jwt_decode(token)) || {};
    if (!(jwt.exp > Date.now() / 1000)) {
      next({ name: 'login', query: { redirectUrl: to.fullPath } });
    }
  }
  next();
});

export default router;
